'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var io = require('orbit-db-io');

module.exports = {
  read: function () {
    var _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfs, cid) {
      var options,
          access,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              _context.next = 3;
              return io.read(ipfs, cid, options);

            case 3:
              access = _context.sent;
              return _context.abrupt("return", typeof access.write === 'string' ? JSON.parse(access.write) : access.write);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function read(_x, _x2) {
      return _read.apply(this, arguments);
    }

    return read;
  }(),
  write: io.write
};